"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ApiError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
/* istanbul ignore file */ class ApiError extends Error {
    constructor(message, data){
        super(message);
        (0, _defineProperty2.default)(this, "data", void 0);
        this.name = 'ApiError';
        this.data = data;
    }
}
exports.ApiError = ApiError;
